export const THUMB_WIDTH = '80px';

export const MULTIPLE_THUMB_WIDTH = '64px';

export const THUMB_HEIGHT = '107px';

export const MULTIPLE_THUMB_HEIGHT = '85px';
